import script from "./GalleryPhotoSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryPhotoSetup.vue?vue&type=script&setup=true&lang=js"

import "./GalleryPhotoSetup.vue?vue&type=style&index=0&id=bb100fe4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb100fe4"]])

export default __exports__